module.exports = __webpack_public_path__ + "static/media/damon-core-jr.50282d14.md";